import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import moment from 'moment'

class SavedSearchesResult extends Component {
  static propTypes = {
    createdAt: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    linkTo: PropTypes.string.isRequired,
    onDelete: PropTypes.func.isRequired,
  }

  render() {
    const { createdAt, id, label, linkTo, onDelete } = this.props

    return (
      <div className="row m-0">
        <div style={{ marginBottom: 8 }}>
          <Link to={linkTo}>
            <div className="row m-0">
              <div style={{ width: 40, textAlign: 'center' }}>
                <i
                  className="fal fa-save"
                  style={{ fontSize: 20, paddingTop: 4 }}
                />
                <div
                  style={{ fontSize: 8, textAlign: 'center', marginTop: -3 }}
                >
                  {createdAt && `${moment(createdAt).format("MMM D")}`}
                </div>
              </div>
              <div className="link-search-box">{label}</div>
              <div className="link-search-button">
                <i className="fal fa-search" />
              </div>
            </div>
          </Link>
        </div>

        <div style={{ marginLeft: -10, marginTop: -10 }}>
          <div onClick={() => onDelete({ id })}>
            <i
              className="fas fa-circle close-x"
              style={{ color: 'white', width: 0 }}
            />
            <i
              className="fal fa-times-circle close-x"
              style={{ color: '#EE6352' }}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default SavedSearchesResult



// WEBPACK FOOTER //
// ./src/components/ui/SavedSearches/SavedSearchesResult.js